import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BaiduMapModule } from "angular2-baidu-map";
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';

import { MainService } from './service/main.service'

import { appRoutes } from './app.routes';
import { HomeModule } from './home/home.module';
import { CommentModule } from './comment/comment.module';

import { AppComponent } from './app.component';
import { ContactComponent } from './contact/contact.component';

@NgModule({
  declarations: [
    AppComponent,
    ContactComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    CommentModule,
    HomeModule,
    RouterModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes,{ useHash: true }),
  ],
  providers: [MainService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/Administrator/submit text project/gwin/src/app/app.module.ts